import axios from 'axios';

export const api = axios.create({
    baseURL: '/'
})


// WEBPACK FOOTER //
// ./src/services/api.js